import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PatientIdentifier } from "@/Common/Models/Patient/PatientIdentifier";

import styles from "./Identifiers.module.scss";

interface OtherIdentifiersEditProps {
    onRemoveOtherId: (identifier: PatientIdentifier) => void;
    onOtherIdentifierNameChange: (identifier: PatientIdentifier, value: string) => void;
    onOtherIdentifierNumberChange: (identifier: PatientIdentifier, value: string) => void;
    onAddOtherId: () => void;
    identifiers: PatientIdentifier[]
}

function OtherIdentifiersEdit(props: OtherIdentifiersEditProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <table>
            {props.identifiers.map((id, idx) => (
                <tbody key={`otherId${idx}_${id.HealthIdentification_id}`} className={styles.identifiers}>
                    <tr>
                        <td className="c1">
                            <label className="form-label">{getText("OrganizationLabel")}</label>
                        </td>
                        <td className="c2">
                            <TextboxControl
                                dataCy="patientProfile-otherIds-organization"
                                value={id.Name}
                                className="form-control"
                                onChange={value => props.onOtherIdentifierNameChange(id, value)}
                                item={id}
                            />
                        </td>
                        <td className="c3 with-line" rowSpan={32}>
                            <span
                                style={{ color: "red", fontWeight: "bold", cursor: "pointer" }}
                                data-cy="patientProfile-otherIds-remove"
                                onClick={() => props.onRemoveOtherId(id)}
                            > X
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className="c1">
                            <label className="form-label">{getText("NumberLabel")}</label>
                        </td>
                        <td className="c2">
                            <TextboxControl
                                dataCy="patientProfile-otherIds-number"
                                value={id.Number}
                                className="form-control"
                                onChange={value => props.onOtherIdentifierNumberChange(id, value)}
                                item={id}
                            />
                        </td>
                    </tr>
                </tbody>
            ))}
            <tbody key="addOtherId">
                <tr>
                    <td className="c1" />
                    <td className="c2" style={{ textAlign: "right" }}>
                        <a
                            data-cy="patientProfile-otherIds-add"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                props.onAddOtherId();
                            }}
                        >
                            {getText("AddLabel")}
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

export { OtherIdentifiersEdit };
